<template>
    <form

        data-yapay="payment-form"
        @submit.prevent="submit"
        method="post"
    >
        <input
            v-model="checkoutSecurity.payment_website"
            type="text"
            name="payment_website"
            autocomplete="off"
            tabindex="-1"
            style="position: absolute; left: -9999px; opacity: 0; pointer-events: none;"
        />
        <input
            type="hidden"
            name="payment_started_at"
            :value="checkoutSecurity.payment_started_at"
        />
        <input
            type="hidden"
            name="device_screen_resolution"
            :value="checkoutSecurity.device_screen_resolution"
        />
        <input
            type="hidden"
            name="device_timezone"
            :value="checkoutSecurity.device_timezone"
        />
        <input
            type="hidden"
            name="device_language"
            :value="checkoutSecurity.device_language"
        />
        <input
            type="hidden"
            name="device_platform"
            :value="checkoutSecurity.device_platform"
        />
        <input
            type="hidden"
            name="device_canvas"
            :value="checkoutSecurity.device_canvas"
        />
        <input
            type="hidden"
            name="device_user_agent"
            :value="checkoutSecurity.device_user_agent"
        />
        <LoadingApp :isLoading.sync="isLoading" :is_full_page="true">
            <template v-slot:content>
                ...aguarde
            </template>
        </LoadingApp>
        <card-template class="card" :key="formKey">
            <div v-if="getShowPaymentMethods == true" class="card-body">
                <legend>
                    Formas de pagamento
                </legend>
                <Fragment
                    v-for="payment in payments"
                    :key="payment.list_key || payment.payment_gateway_id"
                >
                    <Fragment
                        v-if="
                            payment.name == 'PAGSEGURO'
                        "
                    >
                        {{ setPaymentIdPagSeguro(payment.payment_gateway_id) }}
                        <PagSeguro
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formPagSeguroCard.holder"
                            :number.sync="formPagSeguroCard.number"
                            :expiry_month.sync="formPagSeguroCard.expiry_month"
                            :expiry_year.sync="formPagSeguroCard.expiry_year"
                            :cvv.sync="formPagSeguroCard.cvv"
                            :installment.sync="formPagSeguroCard.installment"
                            :cpf.sync="formPagSeguroCard.cpf"
                            :birth.sync="formPagSeguroCard.birth"
                            :total_with_fee.sync="formPagSeguroCard.total_with_fee"
                            :shippingMethod.sync="shippingMethod"
                            :validate.sync="$v"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="payment.name == 'IPAG'">
                        {{ setPaymentIdIpag(payment.payment_gateway_id) }}
                        <Ipag
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formIpagCard.holder"
                            :method.sync="formIpagCard.method"
                            :number.sync="formIpagCard.number"
                            :expiry_month.sync="formIpagCard.expiry_month"
                            :expiry_year.sync="formIpagCard.expiry_year"
                            :cvv.sync="formIpagCard.cvv"
                            :installment.sync="formIpagCard.installment"
                            :validate.sync="$v"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="payment.name == 'BELLUNO CREDITO' && payment.minimun_value <= totalAmount">
                        {{ setPaymentIdBelluno(payment.payment_gateway_id) }}
                        <Belluno
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formBellunoCard.holder"
                            :method.sync="formBellunoCard.method"
                            :number.sync="formBellunoCard.number"
                            :expiry_month.sync="formBellunoCard.expiry_month"
                            :expiry_year.sync="formBellunoCard.expiry_year"
                            :cvv.sync="formBellunoCard.cvv"
                            :installment.sync="formBellunoCard.installment"
                            :cardholder_document.sync="
                                formBellunoCard.cardholder_document
                            "
                            :cardholder_birth.sync="
                                formBellunoCard.cardholder_birth
                            "
                            :cardholder_cellphone.sync="
                                formBellunoCard.cardholder_cellphone
                            "
                            :validate.sync="$v"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="payment.name == 'BELLUNO BOLETO' && payment.minimun_value <= totalAmount">
                        <div
                            v-for="item in payment.payment_method"
                            :key="item.id"
                            class="radio-group "
                            @click="onChangePayment(item)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="item"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.name == 'BELLUNO PIX' && payment.minimun_value <= totalAmount">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="changePaymentPix"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <img :src="$baseUrl+'assets/images/pix.png'" style="width: 20px; height: 20px; float: left; margin: 10px 0px;  margin-left: 0px; margin-left: -2px;">
                                    PIX
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.name == 'MERCADO PAGO'">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    Mercado Pago
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment
                        v-if="
                            payment.name == 'PAGSEGURO BOLETO'
                        "
                    >
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto PagSeguro
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.name == 'IPAG BOLETO'">
                        <div
                            v-for="item in payment.payment_method"
                            :key="item.id"
                            class="radio-group "
                            @click="onChangePayment(item)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="item"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    {{ item.company }}
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <!-- GETNET BOLETO -->
                    <Fragment
                        v-if="
                            payment.id == 11 || payment.name == 'GETNET BOLETO'
                        "
                    >
                        <div
                            v-for="item in payment.payment_method"
                            :key="item.id"
                            class="radio-group "
                            @click="onChangePayment(item)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="item"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto
                                </span>
                            </div>
                        </div>
                    </Fragment>

                    <Fragment v-if="payment.name == 'DINHEIRO'">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-money-bill"></i>
                                    Dinheiro
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.is_customer_method && payment.minimun_value <= totalAmount">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-file-invoice-dollar"></i>
                                    {{ payment.payment_name }}
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.name == 'PIX' && payment.minimun_value <= totalAmount">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="changePaymentPix"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <img :src="$baseUrl+'assets/images/pix.png'" style="width: 20px; height: 20px; float: left; margin: 10px 0px;  margin-left: 0px; margin-left: -2px;">
                                    Pix
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="payment.name == 'GETNET CREDITO'">
                        {{ setPaymentIdIpag(payment.payment_gateway_id) }}
                        <Ipag
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formGetNetCard.holder"
                            :method.sync="formGetNetCard.method"
                            :number.sync="formGetNetCard.number"
                            :expiry_month.sync="formGetNetCard.expiry_month"
                            :expiry_year.sync="formGetNetCard.expiry_year"
                            :cvv.sync="formGetNetCard.cvv"
                            :installment.sync="formGetNetCard.installment"
                            :validate.sync="$v"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="payment.name == 'YAPAY CREDITO'">
                        {{ setPaymentIdYapay(payment.payment_gateway_id) }}
                        <Yapay
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formYapayCard.holder"
                            :method.sync="formYapayCard.method"
                            :number.sync="formYapayCard.number"
                            :expiry_month.sync="formYapayCard.expiry_month"
                            :expiry_year.sync="formYapayCard.expiry_year"
                            :cvv.sync="formYapayCard.cvv"
                            :installment.sync="formYapayCard.installment"
                            :validate.sync="$v"
                            :shippingMethod.sync="shippingMethod"
                            :min_price_installment="payment.price_min_split"
                            :max_installments="payment.max_installments"
                            :total_with_fee="formYapayCard.total_with_fee"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <!-- yapay BOLETO -->
                    <Fragment
                        v-if="
                            payment.id == 13 || payment.name == 'YAPAY BOLETO'
                        "
                    >
                        <div
                            v-for="item in payment.payment_method"
                            :key="item.id"
                            class="radio-group "
                            @click="onChangePayment(item)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="item"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto
                                </span>
                            </div>
                        </div>
                    </Fragment>

                    <!-- PAGARME BOLETO -->
                    <Fragment v-if="payment.name == 'PAGARME BOLETO'">
                        <div
                            v-for="item in payment.payment_method"
                            :key="item.id"
                            class="radio-group "
                            @click="onChangePayment(item)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="item"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <!-- FFLIP GENÉRICO -->
                    <Fragment
                        v-if="
                            payment.company == 'fflip' &&
                                payment.minimun_value <= totalAmount
                        "
                    >
                        <div
                            class="radio-group "
                            @click="onChangePayment(payment)"
                        >
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-money-check-alt"></i>
                                    {{ payment.name }}
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <!-- PAGARME CREDITO -->
                    <Fragment v-if="payment.name == 'PAGARME CREDITO'">
                        {{ setPaymentIdIpag(payment.payment_gateway_id) }}
                        <Pagarme
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formPagarmeCard.holder"
                            :method.sync="formPagarmeCard.method"
                            :number.sync="formPagarmeCard.number"
                            :expiry_month.sync="formPagarmeCard.expiry_month"
                            :expiry_year.sync="formPagarmeCard.expiry_year"
                            :cvv.sync="formPagarmeCard.cvv"
                            :installment.sync="formPagarmeCard.installment"
                            :validate.sync="$v"
                            :shippingMethod.sync="shippingMethod"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="payment.name == 'REDE'">
                        {{ setPaymentIdYapay(payment.payment_gateway_id) }}
                        <Rede
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formRedeCard.holder"
                            :method.sync="formRedeCard.method"
                            :number.sync="formRedeCard.number"
                            :expiry_month.sync="formRedeCard.expiry_month"
                            :expiry_year.sync="formRedeCard.expiry_year"
                            :cvv.sync="formRedeCard.cvv"
                            :installment.sync="formRedeCard.installment"
                            :validate.sync="$v"
                            :shippingMethod.sync="shippingMethod"
                            :min_price_installment="payment.price_min_split"
                            :max_installments="payment.max_installments"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="isSafraCredit(payment)">
                        {{ setPaymentIdSafra(payment.payment_gateway_id) }}
                        <Rede
                            :interest_free_installments="
                                payment.interest_free_installments
                            "
                            :payment_data="payment"
                            :payment_selected.sync="payment_selected"
                            :holder.sync="formSafraCard.holder"
                            :method.sync="formSafraCard.method"
                            :number.sync="formSafraCard.number"
                            :expiry_month.sync="formSafraCard.expiry_month"
                            :expiry_year.sync="formSafraCard.expiry_year"
                            :cvv.sync="formSafraCard.cvv"
                            :installment.sync="formSafraCard.installment"
                            :card_payment_type.sync="formSafraCard.payment_type"
                            :safra_credit_enabled="
                                payment.safrapay_credit_enabled !== false
                            "
                            :safra_debit_enabled="
                                payment.safrapay_debit_enabled === true
                            "
                            :validate.sync="$v"
                            :shippingMethod.sync="shippingMethod"
                            :min_price_installment="payment.price_min_split"
                            :max_installments="payment.max_installments"
                            @onChangePayment="onChangePayment"
                        />
                    </Fragment>
                    <Fragment v-if="isSafraBillet(payment)">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="onChangePayment()"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <i class="fas fa-barcode"></i>
                                    Boleto Safra Pay
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="isSafraPix(payment) && payment.minimun_value <= totalAmount">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="changePaymentPix"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <img :src="$baseUrl+'assets/images/pix.png'" style="width: 20px; height: 20px; float: left; margin: 10px 0px;  margin-left: 0px; margin-left: -2px;">
                                    Pix Safra Pay
                                </span>
                            </div>
                        </div>
                    </Fragment>
                    <Fragment v-if="isPagarmePix(payment) && payment.minimun_value <= totalAmount">
                        <div class="radio-group " @click="onChangePayment(payment)">
                            <div class="radio-heading">
                                <span class="radio-conteiner">
                                    <input
                                        type="radio"
                                        name="payment_radio"
                                        @change="changePaymentPix"
                                        v-model="payment_selected"
                                        :value="payment"
                                    />
                                </span>
                                <span class="forma-conteiner">
                                    <img :src="$baseUrl+'assets/images/pix.png'" style="width: 20px; height: 20px; float: left; margin: 10px 0px;  margin-left: 0px; margin-left: -2px;">
                                    Pix
                                </span>
                            </div>
                        </div>
                    </Fragment>
                </Fragment>
            </div>
            <div class="card-footer text-center">
                <CartDiscount
                    v-if="active_discount_coupon == true"
                    :isPageCheckout="true"
                />
                <span style="text-align: initial;">
                    <h3>
                        Valor total: {{ currency.money(itemsCart.totalAmount) }}
                        <template v-if="show_ipi && !calculateIpi">
                            + IPI
                        </template>
                    </h3>
                </span>
                <span
                    v-if="deliveryRestrictionNotice"
                    style="display: block; color: #c0392b; margin-bottom: 1rem;"
                >
                    {{ deliveryRestrictionNotice }}
                </span>
                <button-finalizar-pedido
                    v-if="itemsCart.list && itemsCart.list.length"
                    type="submit"
                    class="button-finalizar-pedido"
                    :disabled="isLoading || isShippingBusy"
                >
                    <template v-if="isShippingBusy">Calculando o frete...</template>
                    <template v-else>Finalizar {{ isBudgetLayout ? 'orçamento' : 'pedido' }}</template>
                </button-finalizar-pedido>
            </div>
        </card-template>
    </form>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import Currency from "../../helpers/parseCurrency";
import { mapActions, mapGetters, mapState } from "vuex";
import LoadingApp from "../LoadingApp";
import CartDiscount from "../cart/CartDiscount";
import PagSeguro from "./PagSeguro";
import Ipag from "./Ipag";
import { Fragment } from "vue-fragment";
import { CButton, CButtonFinalizarPedido } from "../Styles/Button/styled";
import Yapay from "./Yapay.vue";
import Pagarme from "./Pagarme.vue";
import Rede from "./Rede.vue";
import { CCardTemplate } from "../Styles/Template/styled";
import { CHeading3, CHeading4, CParagraph, CSpan } from "../Styles/Components/styled";
import Belluno from "./Belluno.vue";
import { swall } from '../../services/sweetAlert'
import Permissions from '../../services/Permissions'
import { Modules } from '../../enums/Modules';
import { collectDeviceFingerprint, getCurrentUnixTimestamp } from "../../helpers/deviceFingerprint";

export default {
    name: "PaymentMethods",
    props: {
        company: { required: true },
        payments: {
            required: true,
            type: Array
        },
        csrfToken: {
            required: true
        }
    },
    components: {
        LoadingApp,
        CartDiscount,
        PagSeguro,
        Ipag,
        Fragment,
        "c-button": CButton,
        "button-finalizar-pedido": CButtonFinalizarPedido,
        "card-template": CCardTemplate,
        "c-heading-3": CHeading3,
        "c-paragraph": CParagraph,
        "c-heading-4": CHeading4,
        'c-span': CSpan,
        Yapay,
        Rede,
        Belluno,
        Pagarme
    },
    data() {
        return {
            contents_fb: null,
            isLoading: false,
            active_discount_coupon:
                this.$root.$children[0].$attrs.company?.settings
                    ?.active_discount_coupon ?? true,
            is_required_to_select_seller_at_checkout:
                this.$root.$children[0].$attrs.company?.settings
                    ?.is_required_to_select_seller_at_checkout ?? false,
            affiliate_link_enabled:
                this.$root.$children[0].$attrs.company?.settings
                    ?.affiliate_link_enabled ?? false,
            currency: Currency,
            payment_selected: null,
            payment_id: "",
            payment_type: "",
            countDate: 0,
            formPagSeguroCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "",
                cpf: "",
                birth: "",
                card_token: "",
                class_payment: "\\App\\Payments\\PagSeguroPayment",
                payment_type: "credit",
                observacao: null,
                encryptCard: null,
                total_with_fee: null
            },
            formIpagCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\IpagPayment",
                payment_type: "credit",
                observacao: null
            },
            formBellunoCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\BellunoPayment",
                payment_type: "credit",
                observacao: null,
                cardholder_document: null,
                cardholder_cellphone: null,
                cardholder_birth: null
            },
            formGetNetCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\GetNetPayment",
                payment_type: "credit",
                observacao: null
            },
            formPagarmeCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\PagarmePayment",
                payment_type: "credit",
                observacao: null
            },
            formYapayCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\YapayPayment",
                payment_type: "credit",
                observacao: null,
                total_with_fee: null
            },
            formRedeCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\RedePayment",
                payment_type: "credit",
                observacao: null
            },
            formSafraCard: {
                _token: this.csrfToken,
                payment_gateway_id: "",
                holder: "",
                number: "",
                method: "",
                expiry_month: "",
                expiry_year: "",
                cvv: "",
                installment: "1",
                class_payment: "\\App\\Payments\\SafraPayPayment",
                payment_type: "credit",
                observacao: null,
                safrapay_session_id: ""
            },
            safraPayAntifraud: {
                ready: false,
                loading: false,
                error: null,
                paymentGatewayId: null
            },
            safraPayAntifraudPromise: null,
            pix_data: {},
            url_pix: "",
            formKey: 0,
            checkoutSecurity: {
                payment_website: "",
                payment_started_at: "",
                device_screen_resolution: "",
                device_timezone: "",
                device_language: "",
                device_platform: "",
                device_canvas: "",
                device_user_agent: ""
            }
        };
    },

    validations: {
        formPagSeguroCard: {
            holder: {
                required
            },
            number: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            },
            cpf: {
                required
            },
            birth: {
                required
            }
        },
        formIpagCard: {
            holder: {
                required
            },
            number: {
                required
            },
            method: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        },
        formBellunoCard: {
            holder: {
                required
            },
            number: {
                required
            },
            method: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            },
            cardholder_document: {
                required
            },
            cardholder_cellphone: {
                required
                // minLength: minLength(15)
            },
            cardholder_birth: {
                required
            }
        },
        formYapayCard: {
            holder: {
                required
            },
            number: {
                required
            },
            method: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        },
        formRedeCard: {
            holder: {
                required
            },
            number: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        },
        formSafraCard: {
            holder: {
                required
            },
            number: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        },
        formPagarmeCard: {
            holder: {
                required
            },
            number: {
                required
            },
            method: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        },

        formGetNetCard: {
            holder: {
                required
            },
            number: {
                required
            },
            method: {
                required
            },
            expiry_month: {
                required
            },
            expiry_year: {
                required
            },
            cvv: {
                required
            },
            installment: {
                required
            }
        }
    },
    methods: {
        ...mapActions('cart',['ActionApplyDiscountByPayment','ActionGetItemsCart', 'ActionSetItemsCart', 'ActionApplyIncreaseByPayment']),
        ...mapActions("payment", [
            "ActionSendPayment",
            "ActionGetSafraPayAntifraudConfig",
            "ActionGetPublicKeyPagSeguro"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 7) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000))
        },
        async initializeCheckoutSecurity() {
            const fingerprint = collectDeviceFingerprint();

            this.checkoutSecurity.device_screen_resolution = fingerprint.screen_resolution || "";
            this.checkoutSecurity.device_timezone = fingerprint.timezone || "";
            this.checkoutSecurity.device_language = fingerprint.language || "";
            this.checkoutSecurity.device_platform = fingerprint.platform || "";
            this.checkoutSecurity.device_canvas = fingerprint.canvas || "";
            this.checkoutSecurity.device_user_agent = fingerprint.user_agent || "";

            if (!this.checkoutSecurity.payment_started_at) {
                this.refreshCheckoutSecurityStartedAt();
            }
        },
        refreshCheckoutSecurityStartedAt() {
            this.checkoutSecurity.payment_started_at = getCurrentUnixTimestamp();
        },
        withCheckoutSecurity(payload = {}) {
            return {
                ...payload,
                payment_website: this.checkoutSecurity.payment_website,
                payment_started_at: this.checkoutSecurity.payment_started_at,
                device_screen_resolution: this.checkoutSecurity.device_screen_resolution,
                device_timezone: this.checkoutSecurity.device_timezone,
                device_language: this.checkoutSecurity.device_language,
                device_platform: this.checkoutSecurity.device_platform,
                device_canvas: this.checkoutSecurity.device_canvas,
                device_user_agent: this.checkoutSecurity.device_user_agent,
            };
        },
        ActionSendPayment(payload) {
            return this.$store.dispatch("payment/ActionSendPayment", this.withCheckoutSecurity(payload));
        },

        async initializeSafraPayAntifraud(paymentGatewayId = null) {
            const payment = this.payments.find(item => {
                if (!this.isSafraCredit(item)) {
                    return false;
                }
                return paymentGatewayId === null
                    || Number(item.payment_gateway_id) === Number(paymentGatewayId);
            });

            if (!payment) {
                return null;
            }

            const gatewayId = Number(payment.payment_gateway_id);
            if (this.safraPayAntifraud.ready && this.safraPayAntifraud.paymentGatewayId === gatewayId) {
                return this.safraPayAntifraud;
            }
            if (this.safraPayAntifraudPromise) {
                return this.safraPayAntifraudPromise;
            }

            this.safraPayAntifraud.loading = true;
            this.safraPayAntifraud.error = null;
            this.safraPayAntifraudPromise = (async () => {
                const config = await this.ActionGetSafraPayAntifraudConfig({
                    payment_gateway_id: gatewayId
                });

                await this.loadSafraPayAntifraudScript(config.sdkUrl);
                if (!window.SafraPayAntifraud) {
                    throw new Error("SDK antifraude da SafraPay indisponível.");
                }

                window.SafraPayAntifraud.setCredentials(config.merchantId);
                this.safraPayAntifraud.ready = true;
                this.safraPayAntifraud.paymentGatewayId = gatewayId;
                return this.safraPayAntifraud;
            })();

            try {
                return await this.safraPayAntifraudPromise;
            } catch (error) {
                this.safraPayAntifraud.ready = false;
                this.safraPayAntifraud.error = error;
                throw error;
            } finally {
                this.safraPayAntifraud.loading = false;
                this.safraPayAntifraudPromise = null;
            }
        },

        loadSafraPayAntifraudScript(src) {
            return new Promise((resolve, reject) => {
                if (window.SafraPayAntifraud) {
                    resolve();
                    return;
                }

                let script = document.getElementById("safrapay-antifraud-sdk");
                let shouldAppend = false;
                if (!script) {
                    script = document.createElement("script");
                    script.id = "safrapay-antifraud-sdk";
                    script.src = src;
                    script.async = true;
                    shouldAppend = true;
                }

                const timeout = window.setTimeout(() => {
                    script.remove();
                    reject(new Error("Tempo esgotado ao carregar a SDK antifraude da SafraPay."));
                }, 15000);
                const onLoad = () => {
                    window.clearTimeout(timeout);
                    window.SafraPayAntifraud
                        ? resolve()
                        : reject(new Error("SDK antifraude da SafraPay inválida."));
                };
                const onError = () => {
                    window.clearTimeout(timeout);
                    script.remove();
                    reject(new Error("Falha ao carregar a SDK antifraude da SafraPay."));
                };

                script.addEventListener("load", onLoad, { once: true });
                script.addEventListener("error", onError, { once: true });
                if (shouldAppend) {
                    document.head.appendChild(script);
                }
            });
        },

        async getSafraPaySessionId(paymentGatewayId) {
            await this.initializeSafraPayAntifraud(paymentGatewayId);
            const sessionId = window.SafraPayAntifraud?.getSessionId();
            if (!sessionId) {
                throw new Error("Sessão antifraude da SafraPay não foi gerada.");
            }
            return sessionId;
        },

        onCopyPix: function (e) {
            this.alertToast('Chave copiada para a área de transferência!', 'check', 'success')
        },
        onErrorPix: function (e) {
            this.alertToast('Não foi possível copiar a chave!', 'exclamation-triangle', 'danger')
        },
        async showModalPix() {
            this.payments.forEach(element => {
                console.log(element)
                if (element.name == "PIX" || element.payment_name == "PIX" || element.name == "BELLUNO PIX" || element.payment_name == "BELLUNO PIX") {
                    this.pix_data = element;
                }
            });
            if (!this.shippingMethod?.id && this.showDeliveryMethods) {
                this.isLoading = false;
                let msg = "Selecione um método de entrega!";
                swall(msg, true, 'exclamation-circle', 'secondary',5)
                return
            }
            this.setUrlPix(this.pix_data);
            this.isLoading = true;
        },
        async onChangePayment(data = null) {
            const payment = data ?? this.payment_selected;
            if (!payment) {
                this.payment_selected = null;
                this.payment_type = "";
                return;
            }

            this.payment_selected = payment;
            this.payment_type = payment.type ?? "";
            if (this.isSafraCredit(payment)) {
                const creditEnabled =
                    payment.safrapay_credit_enabled !== false;
                const debitEnabled =
                    payment.safrapay_debit_enabled === true;

                if (!creditEnabled && debitEnabled) {
                    this.formSafraCard.payment_type = "debit";
                    this.formSafraCard.installment = 1;
                } else if (creditEnabled && !debitEnabled) {
                    this.formSafraCard.payment_type = "credit";
                } else if (
                    !["credit", "debit"].includes(
                        this.formSafraCard.payment_type
                    )
                ) {
                    this.formSafraCard.payment_type = "credit";
                }
            }
            this.setClientAndAddress();
            this.refreshCheckoutSecurityStartedAt();
            this.trackAddPaymentInfo(payment);
            await this.setDiscountByPaymentGateway(this.payment_selected.percentage_discount)
            if (this.payment_selected.company === "fflip" && !this.isSafraPay(this.payment_selected)) {
                await this.setIncreaseByPaymentGateway(this.payment_selected.installment_fee)
            }


        },
        trackAddPaymentInfo(payment) {
            try {
                if (typeof gtag !== 'function') {
                    return;
                }

                gtag('event', 'add_payment_info', {
                    'pageTitle': this.company?.nome_fantasia ?? '',
                    'pageCategory': 'Finalização de Pedido - Pagamentos',
                    'ecommerce': {
                        'currency': 'BRL',
                        'value': this.itemsCart?.totalAmount ?? 0,
                        'payment_type': payment?.name ?? this.payment_selected?.name ?? '',
                        'products' : (this.itemsCart?.list ?? []).map(item => ({
                            'id' : item.api_cod_original,
                            'name': item.pro_name_site,
                            'price': item.pro_price_site,
                            'discount' : item.percentage_discount,
                            'quantity' : Number(item.qtd_cart),
                            'variant': item?.items_grid_abbreviaton ??
                                                    `${item?.grid_group_column_value ?? ''}${item?.grid_group_row_value ?? ''}`
                        })),
                    }
                });
            } catch (error) {
                console.warn('Erro ao disparar add_payment_info', error);
            }
        },
        setPaymentIdPagSeguro(id) {
            this.formPagSeguroCard.payment_gateway_id = id;
        },
        setPaymentIdIpag(id) {
            this.formIpagCard.payment_gateway_id = id;
        },
        setPaymentIdBelluno(id) {
            this.formBellunoCard.payment_gateway_id = id;
        },
        setPaymentIdGetNet(id) {
            this.formGetNetCard.payment_gateway_id = id;
        },
        setPaymentIdYapay(id) {
            this.formYapayCard.payment_gateway_id = id;
        },
        setPaymentIdPagarme(id) {
            this.formPagarmeCard.payment_gateway_id = id;
        },
        setPaymentIdRede(id) {
            this.formRedeCard.payment_gateway_id = id;
        },
        setPaymentIdSafra(id) {
            this.formSafraCard.payment_gateway_id = id;
        },
        isSafraPay(payment) {
            const name = String(payment?.name || payment?.payment_name || "").toUpperCase();
            return name === "SAFRA PAY";
        },
        isSafraCredit(payment) {
            return this.isSafraPay(payment) && payment?.type === "credit";
        },
        isSafraPix(payment) {
            return this.isSafraPay(payment) && payment?.type === "pix";
        },
        isSafraBillet(payment) {
            return this.isSafraPay(payment) && payment?.type === "billet";
        },
        isPagarmePix(payment) {
            const name = String(payment?.name || payment?.payment_name || "").toUpperCase();
            return name === "PAGARME PIX";
        },
        setClientAndAddress() {
            this.formBellunoCard.cardholder_document = this.client.user_cpfcnpj;
            this.formBellunoCard.cardholder_birth = this.client.user_birthday?.split("-")
                .reverse()
                .join("/");
            this.formBellunoCard.cardholder_cellphone = this.mainAddress.phone;
        },
        validateForm() {
            let payment = this.payment_selected;
            if (this.payment_type == "billet") {
                return true;
            }
            //1 = pagseguro credito
            if (
                payment.payment_gateway_id == 1 &&
                this.payment_type == "credit"
            ) {
                this.$v.formPagSeguroCard.$touch();
                if (this.$v.formPagSeguroCard.$invalid) {
                    return false;
                }
                return true;
            }
            //1 = ipag credito
            if (
                payment.payment_gateway_id == 3 &&
                this.payment_type == "credit"
            ) {
                this.$v.formIpagCard.$touch();
                if (this.$v.formIpagCard.$invalid) {
                    return false;
                }
                return true;
            }
            //1 = getnet credito
            if (
                payment.payment_gateway_id == 9 &&
                this.payment_type == "credit"
            ) {
                this.$v.formGetNetCard.$touch();
                if (this.$v.formGetNetCard.$invalid) {
                    return false;
                }
                return true;
            }
            //1 = Yapay credito
            if (
                payment.payment_gateway_id == 12 &&
                this.payment_type == "credit"
            ) {
                this.$v.formYapayCard.$touch();
                if (this.$v.formYapayCard.$invalid) {
                    return false;
                }
                return true;
            }

            //1 = pagarme credito
            if (
                payment.payment_gateway_id == 14 &&
                this.payment_type == "credit"
            ) {
                this.$v.formPagarmeCard.$touch();
                if (this.$v.formPagarmeCard.$invalid) {
                    return false;
                }
                return true;
            }

            //1 = pagarme credito
            if (
                payment.payment_gateway_id == 16 &&
                this.payment_type == "credit"
            ) {
                this.$v.formRedeCard.$touch();
                if (this.$v.formRedeCard.$invalid) {
                    return false;
                }
                return true;
            }
            if (this.isSafraCredit(payment)) {
                this.$v.formSafraCard.$touch();
                if (this.$v.formSafraCard.$invalid) {
                    return false;
                }
                return true;
            }
            if (
                payment.payment_gateway_id == 30 &&
                this.payment_type == "credit"
            ) {
                this.$v.formBellunoCard.$touch();
                if (this.$v.formBellunoCard.$invalid) {
                    return false;
                }
                return true;
            }

            return true;
        },

        async submit() {
            if (this.isLoading) {
                return;
            }
            // Enter no formulario passa pelo botao desabilitado
            if (this.isShippingBusy) {
                swall("Aguarde o cálculo do frete terminar para finalizar.", true, 'exclamation-circle', 'secondary', 5)
                return;
            }
            if (this.hasDeliveryRestriction) {
                swall(this.deliveryRestrictionNotice, true, 'exclamation-circle', 'secondary', 5)
                return
            }
            if(this.client?.maximum_purchase_amount && this.client.maximum_purchase_amount > 0 && Number(this.itemsCart.totalAmount) > Number(this.client.maximum_purchase_amount)) {
                let msg = `O seu valor máximo de compra é de ${this.currency.money(this.client.maximum_purchase_amount)}. \nReduza o valor do pedido ou entre em contato conosco!`;
                swall(msg, true, 'exclamation-circle', 'secondary',5)
                return
            }
            if(this.company?.settings?.minimum_purchase_amount && this.company?.settings?.minimum_purchase_amount > 0 && Number(this.itemsCart.totalAmount) < Number(this.company?.settings?.minimum_purchase_amount)) {
                let msg = `Para avançar com o seu pedido, é necessário uma compra mínima de ${this.currency.money(this.company.settings.minimum_purchase_amount)}. \nConvidamos você a explorar mais as nossas novidades, produtos e condições imperdíveis.`;
                swall(msg, true, '', 'secondary',5)
                return
            }
            if(this.itemsCart.list[0].minimum_purchase_amount_supplier && this.itemsCart.list[0].minimum_purchase_amount_supplier > 0 && Number(this.itemsCart.totalAmount) < Number(this.itemsCart.list[0].minimum_purchase_amount_supplier)) {
                let msg = `O valor mínimo de compra do fornecedor ${this.itemsCart.list[0].supplier_name} é de ${this.currency.money(this.itemsCart.list[0].minimum_purchase_amount_supplier)}. \nAumente o valor do pedido ou entre em contato conosco!`;
                swall(msg, true, 'exclamation-circle', 'secondary',5)
                return
            }
            // Com o link de vendedor ligado nao ha vendedor para escolher no checkout.
            if (this.is_required_to_select_seller_at_checkout && !this.affiliate_link_enabled && !this.employee?.value) {
                let msg = (`Escolha um vendedor para finalizar o pedido!`)
                swall(msg, true, 'exclamation-circle', 'secondary',5)
                return
            }

            if (this.activeDeliveryTimesModule && !this.deliveryTime) {
                swall("Escolha um horário de entrega!", true);
                return;
            }
            if(this.getShowPaymentMethods) {
                this.isLoading = true;
                if (!this.payment_selected) {
                    this.isLoading = false;
                    let msg = ("Escolha uma forma de pagamento!");
                    swall(msg, true, 'exclamation-circle', 'secondary',5)
                    return ;
                }
                if (!this.shippingMethod?.id && this.showDeliveryMethods && !this.shippingMethod?.ServiceCode) {
                    this.isLoading = false;
                    let msg = ("Selecione um método de entrega!");
                    swall(msg, true, 'exclamation-circle', 'secondary',5)
                    return ;
                }
                if (!this.mainAddress) {
                    this.isLoading = false;
                    let msg = ("Selecione um local para a entrega!");
                    swall(msg, true, 'exclamation-circle', 'secondary',5)
                    return ;
                }
                if (!this.validateForm()) {
                    this.isLoading = false;
                    return;
                }
                if (this.payment_selected.is_customer_method) {
                    await this.genericPayment();
                    localStorage.removeItem('@cart_coupom_code')
                    return;
                }
                if (this.isSafraPay(this.payment_selected)) {
                    if (this.payment_type === "credit") {
                        await this.safraPayCard();
                    } else if (this.payment_type === "pix") {
                        await this.safraPayPix();
                    } else if (this.payment_type === "billet") {
                        await this.safraPayBillet();
                    } else {
                        await this.genericPayment(this.payment_selected.payment_gateway_id);
                    }
                    localStorage.removeItem('@cart_coupom_code')
                    return;
                }
                // Credito (14) e boleto (15) da Pagar.me tem id fixo no switch
                // abaixo. O gateway de PIX foi criado por seeder e recebe id por
                // auto-increment, que muda de base para base, entao a selecao e
                // por nome como na Safra Pay.
                if (this.isPagarmePix(this.payment_selected)) {
                    await this.pagarmePix();
                    localStorage.removeItem('@cart_coupom_code')
                    return;
                }
                switch (parseInt(this.payment_selected.payment_gateway_id)) {
                    case 1:
                        await this.pagSeguroPaymentCard();
                        break;
                    case 2:
                        await this.mercadoPago();
                        break;
                    case 3:
                        await this.ipagCredit();
                        break;
                    case 4:
                        await this.pagSeguroPaymentBillet();
                        break;
                    case 6:
                        await this.ipagBilletPayment();
                        break;
                    case 8:
                        await this.money();
                        break;
                    case 9:
                        await this.getNetPaymentCard();
                        break;
                    case 10:
                        await this.pix();
                        break;
                    case 11:
                        await this.getNetBilletPayment();
                        break;
                    case 12:
                        await this.yapayCreditPayment();
                        break;
                    case 13:
                        await this.yapayBilletPayment();
                        break;
                    case 14:
                        await this.pagarmeCredit();
                        break;
                    case 15:
                        await this.pagarmeBillet();
                        break;
                    case 16:
                        await this.RedeCredit();
                        break;
                    case 17:
                    case 18:
                    case 19:
                    case 20:
                    case 21:
                    case 22:
                    case 23:
                    case 24:
                    case 25:
                    case 26:
                    case 27:
                    case 28:
                    case 29:
                        await this.genericPayment(
                            this.payment_selected.payment_gateway_id
                        );
                        break;
                    case 30:
                        await this.bellunoCredit();
                        break;
                    case 31:
                        await this.bellunoBilletPayment();
                        break;
                    case 73:
                        await this.bellunoPixPayment();
                        break;
                    default:
                        await this.genericPayment(
                            this.payment_selected.payment_gateway_id
                        );
                        break;
                }
                localStorage.removeItem('@cart_coupom_code')
            } else {
                this.isLoading = true;
                await this.genericPayment();
            }
        },
        setUrlPix() {
            let url = window.location.toString().split("/");
            delete url[url.length - 1];
            url = url.join("/");
            this.url_pix = url + `pix-generate?key=${btoa(Math.random())}`;
        },
        async pagSeguroPaymentBillet() {
            try {
                let data = {
                    hash: this.pagseguro.getSenderHash(),
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\PagSeguroPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                if (error.msg) {
                    swall(error.msg, true, 'exclamation-circle', 'secondary',5)
                    return
                }
                return swall(error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async getNetPaymentCard() {
            // Valida se o campo titular do cartão não está vazio.
            if (
                !window.IPAG.validateHolder(String(this.formGetNetCard.holder))
            ) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formGetNetCard.expiry_month),
                    String(this.formGetNetCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)

            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formGetNetCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                this.formGetNetCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formGetNetCard.payment_type = this.payment_selected.type;
                this.formGetNetCard.observacao = this.observacao;
                const response = await this.ActionSendPayment(
                    this.formGetNetCard
                );
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async pagSeguroPaymentCard() {
            if (
                !window.IPAG.validateHolder(String(this.formPagSeguroCard.holder))
            ) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formPagSeguroCard.expiry_month),
                    String(this.formPagSeguroCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            let card = this.formPagSeguroCard.number.replace(/\s+/g, '')
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(card)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                const requestPagSeguroCard = {
                    payment_gateway_id: this.payment_selected.payment_gateway_id,
                    payment_type: this.payment_selected.type,
                    observacao:this.observacao,
                    _token: this.csrfToken,
                    holder: this.formPagSeguroCard.holder,
                    installment: this.formPagSeguroCard.installment,
                    cpf: this.formPagSeguroCard.cpf,
                    birth: this.formPagSeguroCard.birth,
                    class_payment: "\\App\\Payments\\PagSeguroPayment",
                    encryptCard: null,
                    total_with_fee: this.formPagSeguroCard.total_with_fee
                }
                const public_key = await this.ActionGetPublicKeyPagSeguro()
                requestPagSeguroCard.encryptCard = window.PagSeguroPayment.encryptCard({
                    publicKey: public_key.data,
                    holder: this.formPagSeguroCard.holder,
                    number: this.formPagSeguroCard.number.replace(/\s+/g, ''),
                    expMonth: this.formPagSeguroCard.expiry_month,
                    expYear: this.formPagSeguroCard.expiry_year,
                    securityCode: this.formPagSeguroCard.cvv
                });
                const response = await this.ActionSendPayment(
                    requestPagSeguroCard
                );
                this.isLoading = false;
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async ipagCredit() {
            // Valida se o campo titular do cartão não está vazio.
            if (!window.IPAG.validateHolder(String(this.formIpagCard.holder))) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formIpagCard.expiry_month),
                    String(this.formIpagCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formIpagCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                this.formIpagCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formIpagCard.payment_type = this.payment_selected.type;
                this.formIpagCard.observacao = this.observacao;

                const response = await this.ActionSendPayment(
                    this.formIpagCard
                );
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },

        async bellunoCredit() {
            // Valida se o campo titular do cartão não está vazio.
            if (
                !window.IPAG.validateHolder(String(this.formBellunoCard.holder))
            ) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formBellunoCard.expiry_month),
                    String(this.formBellunoCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formBellunoCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                this.formBellunoCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formBellunoCard.payment_type = this.payment_selected.type;
                this.formBellunoCard.observacao = this.observacao;
                this.formBellunoCard.visitor_id =
                (window.Konduto && typeof window.Konduto.getVisitorID === 'function')
                    ? window.Konduto.getVisitorID()
                    : null;

                const response = await this.ActionSendPayment(
                    this.formBellunoCard
                );
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async pagarmeCredit() {
            // Valida se o campo titular do cartão não está vazio.
            if (
                !window.IPAG.validateHolder(String(this.formPagarmeCard.holder))
            ) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)

            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formPagarmeCard.expiry_month),
                    String(this.formPagarmeCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)

            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formPagarmeCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)

            }
            try {
                this.formPagarmeCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formPagarmeCard.payment_type = this.payment_selected.type;
                this.formPagarmeCard.observacao = this.observacao;

                const response = await this.ActionSendPayment(
                    this.formPagarmeCard
                );
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)

            }
        },
        async RedeCredit() {
            // Valida se o campo titular do cartão não está vazio.
            if (!window.IPAG.validateHolder(String(this.formRedeCard.holder))) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formRedeCard.expiry_month),
                    String(this.formRedeCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formRedeCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                this.formRedeCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formRedeCard.payment_type = this.payment_selected.type;
                this.formRedeCard.observacao = this.observacao;

                const response = await this.ActionSendPayment(
                    this.formRedeCard
                );
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async ipagBilletPayment() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\IpagPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },

        async bellunoBilletPayment() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\BellunoPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async getNetBilletPayment() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\GetNetPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async yapayBilletPayment() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\YapayPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async pagarmeBillet() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\PagarmePayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async genericPayment(method_id) {
            try {
                const selectedPayment = this.payment_selected;
                const isCustomerMethod = !!selectedPayment?.is_customer_method;
                // Forma do Financeiro nao tem gateway: sem payment_gateway_id o
                // backend nao procura payment_company e grava so o vinculo.
                const payment_gateway_id = isCustomerMethod
                    ? null
                    : (selectedPayment?.payment_gateway_id ?? method_id ?? 8);
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\GenericPayment",
                    // Forma do cliente fica sem payment_type, igual ao pedido
                    // manual do painel - o que identifica e o tenant_payment_method_id.
                    payment_type: isCustomerMethod ? null : (selectedPayment?.type ?? "money"),
                    payment_gateway_id,
                    tenant_payment_method_id: isCustomerMethod
                        ? selectedPayment.tenant_payment_method_id
                        : null,
                    method: selectedPayment?.method ?? "money",
                    method_class: "money",
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async yapayCreditPayment() {
            let fingerprint = document.getElementsByName("finger_print");
            if (fingerprint.length) {
                this.formYapayCard.finger_print = fingerprint[0].value;
            }
            // Valida se o campo titular do cartão não está vazio.
            if (
                !window.IPAG.validateHolder(String(this.formYapayCard.holder))
            ) {
                this.isLoading = false;
                let msg = "Titular do cartão é inválido!";
                swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            // Valida se a data de vencimento é válida.
            if (
                !window.IPAG.validateExpiration(
                    String(this.formYapayCard.expiry_month),
                    String(this.formYapayCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                let msg = "Vencimento do cartão é inválido.";
                swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            if (
                !window.IPAG.validateCreditCardNumber(
                    String(this.formYapayCard.number)
                )
            ) {
                this.isLoading = false;
                let msg = "Número do cartão é inválido.";
                swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
            try {
                this.formYapayCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formYapayCard.payment_type = this.payment_selected.type;
                this.formYapayCard.observacao = this.observacao;
                const response = await this.ActionSendPayment(
                    this.formYapayCard
                );
                this.isLoading = false;
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async mercadoPago() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\MercadoPagoPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                const response = await this.ActionSendPayment(data);
                window.location.href = response.init_point;
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },

        async money() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\MoneyPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)            }
        },
        async pix() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\PixPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)            }
        },
        async bellunoPixPayment() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\BellunoPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected
                        .payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)            }
        },
        async safraPayCard() {
            if (!window.IPAG.validateHolder(String(this.formSafraCard.holder))) {
                this.isLoading = false;
                return swall("Titular do cartão é inválido!", true, 'exclamation-circle', 'secondary',5)
            }
            if (
                !window.IPAG.validateExpiration(
                    String(this.formSafraCard.expiry_month),
                    String(this.formSafraCard.expiry_year)
                )
            ) {
                this.isLoading = false;
                return swall("Vencimento do cartão é inválido.", true, 'exclamation-circle', 'secondary',5)
            }
            if (!window.IPAG.validateCreditCardNumber(String(this.formSafraCard.number))) {
                this.isLoading = false;
                return swall("Número do cartão é inválido.", true, 'exclamation-circle', 'secondary',5)
            }

            try {
                this.formSafraCard.payment_gateway_id = this.payment_selected.payment_gateway_id;
                this.formSafraCard.observacao = this.observacao;
                this.formSafraCard.safrapay_session_id = await this.getSafraPaySessionId(
                    this.payment_selected.payment_gateway_id
                );
                await this.ActionSendPayment(this.formSafraCard);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async safraPayBillet() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\SafraPayPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected.payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async pagarmePix() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\PagarmePayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected.payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async safraPayPix() {
            try {
                const data = {
                    _token: this.csrfToken,
                    class_payment: "\\App\\Payments\\SafraPayPayment",
                    payment_type: this.payment_selected.type,
                    payment_gateway_id: this.payment_selected.payment_gateway_id,
                    method: this.payment_selected.method,
                    observacao: this.observacao
                };
                await this.ActionSendPayment(data);
                window.location.href = this.$baseUrl + "completed-purchase";
            } catch (error) {
                this.isLoading = false;
                swall(error?.msg ?? error?.message ?? error, true, 'exclamation-circle', 'secondary',5)
            }
        },
        async setDiscountByPaymentGateway(discount) {
            const paymentType = String(this.payment_selected?.type ?? this.payment_selected?.payment_method_type ?? '').toLowerCase()
            const payload = {
                payment_gateway_id : this.payment_selected.payment_gateway_id,
                payment_type: paymentType
            }
            if((!discount || discount <= 0) && paymentType !== 'pix') {
                payload.payment_gateway_id = null
            }
            await this.ActionApplyDiscountByPayment(payload)

            await this.ActionGetItemsCart()
            .then((result) => {
                this.ActionSetItemsCart(result.data)
            }).catch((err) => {
                console.log(err)
            });
        },
        async setIncreaseByPaymentGateway(increase) {
            const payload = {
                payment_gateway_id : this.payment_selected.payment_gateway_id
            }
            if(!increase || increase <= 0 ) {
                payload.payment_gateway_id = null
            }
            await this.ActionApplyIncreaseByPayment(payload)

            await this.ActionGetItemsCart()
            .then((result) => {
                this.ActionSetItemsCart(result.data)
            }).catch((err) => {
                console.log(err)
            });
        },
        async changePaymentPix() {
            await this.onChangePayment()
        },
        setPaymentDefault(payment) {
            if(payment === false) {
                this.payment_selected = this.payments?.find(el => el.id == 24)
                if (this.payment_selected) {
                    this.onChangePayment(this.payment_selected)
                }
            }
        }
    },
    mounted() {
        this.initializeCheckoutSecurity();
        this.initializeSafraPayAntifraud().catch(() => {});
        this.setPaymentDefault(this.getShowPaymentMethods)
    },
    computed: {
        ...mapState("cart", ["itemsCart",'checkoutKey']),
        /**
         * Entrega exclusiva por transportadora: enquanto houver item que nao
         * chega no cep do cliente, o pedido nao fecha. A trava de verdade esta
         * no back (PaymentHelper), isso aqui so evita a ida ate o erro. O botao
         * nao fica disabled para o clique chegar no submit e mostrar o aviso.
         */
        hasDeliveryRestriction() {
            return (this.itemsCart?.deliveryRestriction?.blocked ?? []).length > 0
        },
        deliveryRestrictionNotice() {
            const blocked = this.itemsCart?.deliveryRestriction?.blocked ?? []
            if(!blocked.length) {
                return null
            }
            return [...new Set(blocked.map(item => item.message))].join(' ')
        },
        ...mapState("shipping", ["shippingMethod"]),
        ...mapState("address", ["mainAddress"]),
        ...mapState("payment", ["observacao"]),
        ...mapState("company", ["facebookPixel", "googleAds"]),
        ...mapState("clients", ["client"]),
        ...mapState("employee", ["employee"]),
        ...mapState("deliveryTimes", ["deliveryTime"]),
        ...mapGetters("shipping", [
            'isShippingBusy',
            'getCorreios',
            'getRodonaves',
            'getFflipFretes',
            'getMelhorEnvio',
            'getJadlog',
            'getAcExpress',
            'getAceville',
            'getBraspress',
            'getBauer',
            'getExpressoSaoMiguel',
            'getZanotelli',
            'getTNT',
            'getTodoBrasil',
            'getAcevilleTdaTde',
            'getAzurelog',
            'getEbTrans',
            'getRodovitor',
            'getAgex',
            'getFariasFaz',
            'getScLogistica',
            'getAlfa',
            'getAtiva',
            'getTotalExpress'
        ]),
        ...mapGetters('company',[
            "getCompanySettings",
            "getShowPaymentMethods",
            "showDeliveryMethods",
            "showIpi",
            "workWithOrder"
        ]),
        totalAmount() {
            return this.itemsCart.totalAmount;
        },
        show_ipi() {
            return (this.showIpi && this.itemsCart?.list?.some(el => el?.ipi_percentage))
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        activeDeliveryTimesModule() {
            return (
                this.workWithOrder &&
                Permissions.checkModule(Modules.HORARIOS_DE_ENTREGA)
            );
        },
        calculateIpi() {
            return this.$root.$children[0].$attrs.company?.settings?.calculate_ipi ?? false
        }
    },
    watch: {
        getShowPaymentMethods(payment) {
            this.setPaymentDefault(payment)
        },
        active_discount_coupon(val) {
        // Atualiza o método de pagamento após aplicar cupom
            if (val) {
                this.onChangePayment(this.payment_selected)
            }
        },
        totalAmount(val, oldVal) {
            if (val !== oldVal) {
                this.onChangePayment(this.payment_selected)
            }
        }
    }
};
</script>
